import { createFileRoute } from '@tanstack/react-router'
import { TransactionsTable } from '@/features/transactions'

export const Route = createFileRoute('/_authenticated/wallet/transactions')({
  component: TransactionsPage,
})

function TransactionsPage() {
  return <TransactionsTable />
}
